import { useQuery } from '@tanstack/react-query'
import { FolderXIcon } from 'lucide-react'

import { getUserQuery } from '@/lib/queries/business/v2/user/queries'
import { isNumber } from '@/lib/types/predicate'

import { numberFormatter } from '../constants'

export const InactiveCasesContent = () => {
  const { data: dataUser } = useQuery(getUserQuery)

  const inactiveCases = dataUser?.extraProductInfo.inactiveCases

  return (
    <>
      <span>
        <FolderXIcon size={16} />
      </span>
      <div className="text-xs text-muted-foreground">
        Inactive {isNumber(inactiveCases) ? numberFormatter.format(inactiveCases) : '-'}
      </div>
    </>
  )
}
